module.exports = __webpack_public_path__ + "static/img/it4d-e-samu.4093e30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/it4d-e-samu.png
// module id = sAll
// module chunks = 4